import { Provider, signal } from '@angular/core';

import { ATTENTION_PROJECTIONS, AttentionProjection } from '@shared/services/attention/attention-projections';

/** The rail items the grocery's badges decorate — the pages-config urls of its children. */
export const GROCERY_RAIL = {
  dates: '/provider/app/grocery/dates',
} as const;

/* What the grocery store last counted, published here so the ROOT projection reads it without
   importing the store — which would pull the whole grocery into the app's initial chunk (the 7 MB
   budget, M2; the restaurant's and the salon's pattern). Until the grocery has been opened this
   session there is nothing counted, and no badge. */
const DUE_TODAY = signal(0);

/** The store's one write — the lots due today. */
export function publishGroceryBadges(dueToday: number): void {
  if (DUE_TODAY() !== dueToday) {
    DUE_TODAY.set(dueToday);
  }
}

/**
 * Grocery's rail badge (GR-15, D436): the lots DUE TODAY (`days <= 0`, still on the shelf) — the
 * same set the Dates screen's *Due today* tab lists (D283), never tomorrow's. It carries `expiry`,
 * so a tenant without the capability shows no count.
 */
export function groceryAttentionProjections(): readonly AttentionProjection[] {
  return [
    {
      rule: { id: 'grocery.expiry.due', moduleId: 'grocery', capKey: 'expiry', railItemId: GROCERY_RAIL.dates, enabled: true, scope: 'site' },
      count: DUE_TODAY.asReadonly(),
    },
  ];
}

/** Register the grocery's projections at the root (AppModule), so the shell can show them. */
export function provideGroceryAttention(): Provider[] {
  return [{ provide: ATTENTION_PROJECTIONS, useValue: groceryAttentionProjections, multi: true }];
}
